import IPlanTemplate from './IPlanTemplate';
import IPlanTemplateInput from './IPlanTemplateInput';
import IFileUploads from './IFileUploads';
import * as ActionTypes from './ActionTypes';
import PlanTemplatesApi from './PlanTemplatesApi';

function createSucceeded(result: any): any {
    return { type: ActionTypes.CREATE_PLAN_TEMPLATE_SUCCESS, result: result };
}

export function create(
    input: IPlanTemplateInput,
    fileuploads: IFileUploads
): (dispatch: (result: any) => void, getState: any) => void {
    return (dispatch: (result: any) => void, getState: any) =>
        PlanTemplatesApi.create(input, fileuploads).then((result: IPlanTemplate) => {
            dispatch(createSucceeded(result));
        });
}

function UploadFilesSucceeded(result: IPlanTemplate): any {
    return { type: ActionTypes.UPLOAD_FILES_TEMPLATE_SUCCESS, result: result };
}

export function uploadFiles(
    id: number,
    fileuploads: IFileUploads
): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        PlanTemplatesApi.uploadFiles(id, fileuploads).then((result: any) => {
            dispatch(UploadFilesSucceeded(result));
        });
}

function deleteSucceeded(result: number) {
    return { type: ActionTypes.DELETE_PLAN_TEMPLATE_SUCCESS, result };
}

export function deletePlanTemplate(id: number) {
    return (dispatch: (result: any) => void) =>
        PlanTemplatesApi.delete(id).then((result: any) => {
            dispatch(deleteSucceeded(id));
        });
}

function clearStateDispatchObject(result: any): any {
    return { type: ActionTypes.CLEAR_PLAN_TEMPLATE_STATE, result };
}

export function clearState() {
    return (dispatch: (result: any) => void) => dispatch(clearStateDispatchObject(''));
}

export function listSucceeded(result: IPlanTemplate[]) {
    return { type: ActionTypes.LIST_PLAN_TEMPLATE_SUCCESS, result: result };
}

export function list(): (dispatch: (result: any) => void, getState: any) => any {
    return (dispatch: (result: any) => void, getState: any) =>
        PlanTemplatesApi.list().then((result: IPlanTemplate[]) => {
            dispatch(listSucceeded(result));
        });
}

function updateSuccess(result: any) {
    return { type: ActionTypes.UPDATE_PLAN_TEMPLATE_SUCCESS, result: result };
}

export function update(planTemplate: IPlanTemplateInput, fileuploads: IFileUploads, id: number) {
    return (dispatch: any) =>
        PlanTemplatesApi.update(planTemplate, fileuploads, id).then((result: IPlanTemplate) => {
            dispatch(updateSuccess(result));
        });
}
